import jQuery from 'jquery';
import OBSWebSocket from 'obs-websocket-js';

export default class ProxyReceiverJS {
    #obs;
    #receiver;
    #proxy;
    #senderUrl;
    #receiverUrl;
    #receiving;
    #receiveTimer;
    #errorCounter;

    constructor(url, proxy, receiver) {
        this.#proxy = proxy;
        this.#receiver = receiver;
        if (!url.endsWith('/')) {
            url += '/';
        }
        this.#errorCounter = 0;
        this.#senderUrl = url + 'send.php';
        this.#receiverUrl = url + 'receive.php';
        this.#obs = new OBSWebSocket();
        var origEmit = this.#obs.emit;
        this.#obs.emit = (...args) => {
            jQuery.ajax({
                url: this.#senderUrl,
                method: 'POST',
                context: this,
                data: {
                    proxy: this.#proxy,
                    sender: this.#receiver,
                    method: 'on',
                    data: JSON.stringify(args),
                },
            });
            origEmit.apply(this.#obs, args);
        };
        this.startReceiving();
    }

    #receive = function () {
        if (this.#receiveTimer !== undefined) {
            clearTimeout(this.#receiveTimer);
            this.#receiveTimer = undefined;
        }
        jQuery.ajax({
            url: this.#receiverUrl,
            context: this,
            method: 'POST',
            data: {
                proxy: this.#proxy,
                receiver: this.#receiver,
            },
        })
            .done(data => {
                data.forEach(message => {
                    this.#errorCounter = 0;
                    if ('id' in message && 'method' in message) {
                        var data = {};
                        if ('data' in message) {
                            data = JSON.parse(message.data);
                        }
                        var promise;
                        switch (message.method) {
                            case 'connect':
                                promise = this.#obs.connect(data);
                                break;
                            case 'send':
                                if ('method' in data) {
                                    if (!('args' in data)) {
                                        data.args = {};
                                    }
                                    promise = this.#obs.send(data.method, data.args);
                                } else {
                                    promise = Promise.reject('send(metod, {args}): method is missing');
                                }
                                break;
                            case 'disconnect':
                                promise = this.#obs.disconnect();
                                if (!(promise instanceof Promise)) {
                                    window.close();
                                }
                                break;
                            default:
                                promise = Promise.reject('Method \'' + message.method + '\' unknown.')
                        }
                        console.log('Message processed, checking Promise...')
                        if (promise instanceof Promise) {
                            console.log('Promise checked')
                            promise.then(
                                (...args) => {
                                    console.log('Resolve!')
                                    this.send(message.method, { promise: 'resolve', arg: args || [] }, message.id);
                                },
                                (...args) => {
                                    console.log('Reject!')
                                    this.send(message.method, { promise: 'reject', arg: args || [] }, message.id);
                                }
                            );
                        }
                    }
                });
            })
            .fail(() => {
                this.#errorCounter++;
            //    if (this.#errorCounter > 10) {
            //        this.stopReceiving();
            //        throw 'Errorcounter: ' + this.#errorCounter + ", Receiving stopped.";
            //    }
            })
            .always(() => {
                if (this.#receiving) {
                    let timeout = 10;
                    if (this.#errorCounter > 10) {
                        timeout = Math.min(10000, 10 ** (this.#errorCounter / 10))
                    }
                    this.#receiveTimer = setTimeout(this.#receive.bind(this), timeout);
                }
            });
    }

    startReceiving = function () {
        this.#errorCounter = 0;
        if (!this.#receiving) {
            this.#receiving = true;
            this.#receive();
        }
    }

    stopReceiving = function () {
        this.#receiving = false;
        clearTimeout(this.#receiveTimer);
        this.#receiveTimer = undefined;
    }

    send = function (method, data = {}, ref) {
        jQuery.ajax({
            url: this.#senderUrl,
            data: {
                method: method,
                data: JSON.stringify(data),
                ref: ref,
                sender: this.#receiver,
                proxy: this.#proxy,
            },
            context: this,
            method: 'POST',
        }).done(function (data) {
            console.log({ status: 'Message sent', data: data });
            // Success
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.log({ textStatus: textStatus, errorThrown: errorThrown, jqXHR: jqXHR });
            // Error
        });
    }
}